import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNotification} from '../../contexts/NotificationContext';
import {NotificationDto} from "../../types/notification";
import useNotificationService from '../../services/notification';
import {useJwt} from "../../helpers/common";

const NotificationListener = () => {
  const deltaNotifications = useSelector((state: any) => state.notification.deltaNotifications);
  const { showGroupedNotification } = useNotification();
  const {
    markNotificationsAsDisplayed,
    fetchDeltaNotifications,
    fetchNotifications: fetchAllNotifications
  } = useNotificationService();
  const jwtData: any = useJwt();

  const fetchNotifications = async () => {
    if(jwtData.org_id && !window.location.pathname.includes("notification")) {
      await fetchDeltaNotifications(jwtData.org_id);
    }
  }

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    interval = setInterval(fetchNotifications, 5000);
    return () => clearTimeout(interval);
  });

  useEffect(() => {
    if(jwtData.org_id) {
      fetchNotifications();
      fetchAllNotifications(jwtData.org_id);
    }
  }, [jwtData.org_id]);

  useEffect(() => {
    if (deltaNotifications && deltaNotifications.length > 0) {
      // Group notifications by entity_type
      const groupedNotifications = deltaNotifications.reduce((acc: Record<string, NotificationDto[]>, notification: NotificationDto) => {
        if (!acc[notification.entity_type]) {
          acc[notification.entity_type] = [];
        }
        acc[notification.entity_type].push(notification);
        return acc;
      }, {});

      // Show each group as toast
      Object.entries(groupedNotifications).forEach(([entityType, notifications]) => {
        const typedNotifications = notifications as NotificationDto[];
        
        // Get the latest notification (first in array as backend sends latest first)
        const latestNotification = typedNotifications[0];
        
        // Show the grouped notification
        showGroupedNotification(latestNotification, typedNotifications);
      });

      // Mark all delta notifications as displayed - only when we actually have notifications to show
      const notificationIds = deltaNotifications.map((notification: NotificationDto) => notification.id);
      if(notificationIds.length > 0) {
        markNotificationsAsDisplayed(notificationIds);
      }
    }
  }, [deltaNotifications, showGroupedNotification]); // Removed markNotificationsAsDisplayed from dependencies

  return null; // This component doesn't render anything visible
};

export default NotificationListener; 